document.addEventListener("DOMContentLoaded", function () {
    const navbar = document.querySelector(".navbar");
    const simpleDropdowns = document.querySelectorAll(".navbar-link.is-simple-dropdown-toggle");
    const menuButton = document.querySelector(".navbar-menu-button");
    let removeTimeout;

    // === Navbar dropdown behavior ===
    function updateNavbarState() {
        const isAnyOpen =
            [...simpleDropdowns].some(dropdown => dropdown.classList.contains("w--open")) ||
            menuButton.classList.contains("w--open");

        if (isAnyOpen) {
            clearTimeout(removeTimeout);
            navbar.classList.add("is-open");
        } else {
            removeTimeout = setTimeout(() => {
                navbar.classList.remove("is-open");
            }, 300);
        }
    }

    const dropdownObserver = new MutationObserver(updateNavbarState);
    simpleDropdowns.forEach(dropdown =>
        dropdownObserver.observe(dropdown, { attributes: true, attributeFilter: ["class"] })
    );
    dropdownObserver.observe(menuButton, { attributes: true, attributeFilter: ["class"] });

    simpleDropdowns.forEach(toggle => {
        toggle.addEventListener("click", () => {
            // Espacio reservado para futura lógica
        });
    });

    // Delegado en document: el configurador reemplaza el contenido del carrito al agregar (fr-configurator.js)
    // y un listener puesto en el botón original se pierde con él.
    document.addEventListener("click", function (event) {
        const button = event.target.closest(".is-close-drawer");
        const dropdown = button && button.closest(".w-dropdown");
        if (!dropdown) return;
        event.preventDefault();
        setTimeout(() => {
            const dropdownToggle = dropdown.querySelector(".w-dropdown-toggle.w--open");
            const dropdownList = dropdown.querySelector(".w-dropdown-list.w--open");

            if (dropdownToggle) dropdownToggle.classList.remove("w--open");
            if (dropdownList) dropdownList.classList.remove("w--open");
        }, 500);
    });

    // === NUEVO: Cierre de dropdown nativo al hacer click en botón de cierre personalizado ===
    document.querySelectorAll('.filter-dropdown-drawer-close-button').forEach(button => {
        button.addEventListener('click', () => {
            const dropdown = button.closest('.w-dropdown');
            if (dropdown) {
                const toggle = dropdown.querySelector('.w-dropdown-toggle');
                if (toggle) {
                    // Disparar mousedown + mouseup para emular un click real
                    ['mousedown', 'mouseup'].forEach(evtType => {
                        const event = new MouseEvent(evtType, {
                            view: window,
                            bubbles: true,
                            cancelable: true,
                            buttons: 1
                        });
                        toggle.dispatchEvent(event);
                    });
                }
            }
        });
    });

    // Cerrar el cajón de Filtrar al hacer click en su fondo (un ::before del dropdown en custom.css, que cubre toda la
    // página: el click llega con target === dropdown). Se detiene en captura para que la interacción de Webflow del
    // dropdown no lo vuelva a abrir, y se cierra con su botón de cerrar, que es el que tiene la interacción de cierre.
    document.addEventListener('click', event => {
        const drawer = event.target.matches('.w-dropdown')
            && event.target.querySelector(':scope > .filter-dropdown-drawer[style*="display: block"]');
        if (!drawer) return;
        event.preventDefault();
        event.stopPropagation();
        drawer.querySelector('.filter-dropdown-drawer-close-button')?.click();
    }, true);

    // Escape también cierra el cajón abierto.
    document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        document.querySelector('.w-dropdown > .filter-dropdown-drawer[style*="display: block"] .filter-dropdown-drawer-close-button')?.click();
    });

    // Al cerrar, el fondo se desvanece junto con el cajón (Webflow lo desliza 350 ms y luego lo oculta de golpe).
    document.addEventListener('click', event => {
        const dropdown = event.target.closest('.filter-dropdown-drawer-close-button')?.closest('.w-dropdown');
        if (!dropdown) return;
        dropdown.classList.add('fr-closing');
        setTimeout(() => dropdown.classList.remove('fr-closing'), 600);
    }, true);

    // === Dynamic color behavior ===
    let currentTextColor = null;
    let currentGradientColor = null;
    let rafPending = false;

    function getScrollThresholdFromCSS() {
        const temp = document.createElement('div');
        temp.style.position = 'absolute';
        temp.style.visibility = 'hidden';
        temp.style.pointerEvents = 'none';
        temp.style.height = 'calc(var(--_sizing---logo-sizing--scrolled) + (2 * var(--_sizing---spacing--xs)))';
        document.body.appendChild(temp);
        const pxValue = parseFloat(getComputedStyle(temp).height);
        document.body.removeChild(temp);
        return pxValue;
    }

    function isInViewport(el, threshold) {
        const rect = el.getBoundingClientRect();
        return rect.top <= threshold && rect.bottom >= threshold;
    }

    function getVisibleSlideColor(slider, threshold) {
        if (!isInViewport(slider, threshold)) return null;

        const visibleSlide = [...slider.querySelectorAll('.slide')]
            .find(s => getComputedStyle(s).visibility !== "hidden");

        if (visibleSlide && visibleSlide.hasAttribute("data-text-color") && visibleSlide.hasAttribute("data-gradient-color")) {
            return {
                textColor: visibleSlide.getAttribute("data-text-color"),
                gradientColor: visibleSlide.getAttribute("data-gradient-color"),
                sliderEl: slider
            };
        }

        return null;
    }

    function applyColors(textColor, gradientColor, sliderEl = null) {
        if (rafPending) return;
        rafPending = true;

        requestAnimationFrame(() => {
            rafPending = false;

            if (textColor === currentTextColor && gradientColor === currentGradientColor) return;

            currentTextColor = textColor;
            currentGradientColor = gradientColor;

            document.body.style.setProperty("--navbar-colors--text", textColor, "important");
            document.body.style.setProperty("--navbar-colors--gradient", gradientColor, "important");

            navbar.style.setProperty("--navbar-colors--text", textColor, "important");
            navbar.style.setProperty("--navbar-colors--gradient", gradientColor, "important");

            if (sliderEl) {
                sliderEl.style.setProperty("--navbar-colors--text", textColor, "important");
                sliderEl.style.setProperty("--navbar-colors--gradient", gradientColor, "important");
            }
        });
    }

    function updateNavbarColors() {
        const threshold = getScrollThresholdFromCSS();
        const allTargets = document.querySelectorAll("[data-text-color][data-gradient-color]");

        const sliders = document.querySelectorAll(".slider");
        for (const slider of sliders) {
            const result = getVisibleSlideColor(slider, threshold);
            if (result) {
                applyColors(result.textColor, result.gradientColor, result.sliderEl);
                return;
            }
        }

        for (const el of allTargets) {
            const rect = el.getBoundingClientRect();
            if (rect.top <= threshold && rect.bottom >= threshold) {
                const textColor = el.getAttribute("data-text-color");
                const gradientColor = el.getAttribute("data-gradient-color");
                applyColors(textColor, gradientColor);
                return;
            }
        }
    }

    window.addEventListener("scroll", () => {
        requestAnimationFrame(updateNavbarColors);
    });

    updateNavbarColors();

    const sliders = document.querySelectorAll(".slider");
    sliders.forEach(slider => {
        const slides = slider.querySelectorAll(".slide");
        slides.forEach(slide => {
            const observer = new MutationObserver(() => {
                updateNavbarColors();
            });

            observer.observe(slide, {
                attributes: true,
                attributeFilter: ["style", "class", "aria-hidden"]
            });
        });
    });
});
// Videos decorativos: con "reducir movimiento" se quedan en el primer cuadro.
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('[data-fr-video]').forEach(function (video) {
    video.removeAttribute('autoplay');
    video.pause();
  });
}
